import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { WarningModal } from "../../../components/WarningModal";
import { KanbanAutomationRule } from "../../../model/kanban/KanbanAutomationRule";
import { kanbanSliceSelectors } from "../../../redux/kanban/kanban.selector";
import { kanbanActions } from "../../../redux/kanban/kanban.slice";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { userSliceSelectors } from "../../../redux/user/user.selector";
import { AtiraToast } from "../../../utils/AtiraToast";

type KanbanAutomationRuleDeleteModalProps = {
  rule: KanbanAutomationRule | null;
  onClose: VoidFunction;
};

export const KanbanAutomationRuleDeleteModal: React.FC<
  KanbanAutomationRuleDeleteModalProps
> = ({ rule, onClose }) => {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const kanban = useAppSelector(kanbanSliceSelectors.selectUserCurrentKanban);

  const onDelete = async () => {
    try {
      setLoading(true);
      await dispatch(
        kanbanActions.deleteAutomationRule({
          userId,
          kanbanId: kanban!._id,
          ruleId: rule!._id,
        }),
      ).unwrap();

      AtiraToast.success(t("kanban.automation.rule.delete.success"));
      onClose();
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <WarningModal
      isOpen={Boolean(rule)}
      onClose={onClose}
      title={t("kanban.automation.rule.delete.title")}
      description={t("kanban.automation.rule.delete.description")}
      onConfirm={onDelete}
      confirmButtonText={t("common.delete")}
      loading={loading}
    />
  );
};
